import type { ItemMenu } from './Menu';

export type QuickAccessEnvironment = 'CUSTOMIZER' | 'COMPOSER' | 'VIEWER';

const TOOL_TO_QUICK_ACCESS_ENVIRONMENT: Record<number, QuickAccessEnvironment> = {
    1: 'CUSTOMIZER',
    2: 'COMPOSER',
    3: 'VIEWER'
};

export const getQuickAccessEnvironment = (lastUsedTool: number): QuickAccessEnvironment => TOOL_TO_QUICK_ACCESS_ENVIRONMENT[lastUsedTool] ?? 'CUSTOMIZER';

export interface LeftAppSidebarState {
    currentMenuKey?: string;
    currentMenuUrlPage?: string;
    openCategories?: Record<string, boolean>;
}

export interface SidebarMenuItemsProps {
    homeMenu: ItemMenu;
    currentMenu: ItemMenu;
    goToMenu(item: ItemMenu): void;
    onBackClick(): void;
    expandedCategoryKey?: string | null;
    onExpandedCategoryOpened?: () => void;
    initialOpenCategories?: Record<string, boolean>;
    onOpenCategoriesChange?: (openCategories: Record<string, boolean>) => void;

    iamUser: boolean;
    iamUserPermissions: string[];
}
